import { urls } from "../Urls";
import { Http } from "../Http";

/** memberType is omitted for the All tab; API rejects an empty array */
export type UpdateFeatureClientMappingPayload = {
  clientId: number;
  menuId: number[];
  featureIds: number[];
  isDeleted: boolean;
  memberType?: string[];
};

/** All tab sends [""] — the field is required by the API */
export type UpdateMenuSequencePayload = {
  clientId: number;
  memberType: string[];
  orderedMenuIds: number[];
};

export class FeatureApi {
  static getAllMenusAndFeatures(memberType?: string) {
    return Http.get(urls.feature.getAllMenusAndFeatures(memberType));
  }

  static getApplicationFeaturesAndMenus(memberType?: string) {
    return Http.get(urls.feature.getApplicationFeaturesAndMenus(memberType));
  }

  /**
   * Uses existing Http.post — ClientId header (REACT_APP_PAYER_ID) is fine
   * alongside body.clientId; header is for API routing, body is the payload.
   */
  static updateFeatureClientMapping(data: UpdateFeatureClientMappingPayload) {
    return Http.post(urls.feature.updateFeatureClientMapping, data);
  }

  static updateMenuSequence(data: UpdateMenuSequencePayload) {
    return Http.post(urls.feature.updateMenuSequence, data);
  }
}
